import React from "react";
import { CheckBox } from "devextreme-react/check-box";
import "./style.scss";

export default function Insurance({ insurance = {}, convertDateTime }) {
  const {
    IsSocialInsurance,
    IsHealthyInsurance,
    IsUnemploymentInsurance,
    InsStartDate,
    HouseholdNo,
    InsuranceBookNo,
  } = insurance;
  return (
    <React.Fragment>
      <div className="form-readonly ma-2">
        <div className="form-col">
          <CheckBox
            defaultValue={IsSocialInsurance}
            readOnly={true}
            text="Join Social Insurance"
            className="mb-2"
          />
          <br />
          <CheckBox
            defaultValue={IsHealthyInsurance}
            readOnly={true}
            text="Join health insurance"
            className="mb-2"
          />
          <br />
          <CheckBox
            defaultValue={IsUnemploymentInsurance}
            readOnly={true}
            text="Join Unemployment Insurance"
          />
          <br />
          <br />
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Ins Start Date</div>
            <div className="form-value">
              <span>{convertDateTime(InsStartDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Household No</div>
            <div className="form-value">
              <span>{HouseholdNo}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Insurance Book No</div>
            <div className="form-value">
              <span>{InsuranceBookNo}</span>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
